import img1 from "../../images/pacific oahu open.jpg";

function PastTourn() {
  return (
    <div className="row justify-content-center text-center mb-5">
      <div className="view-events justify-content-center">
        <img src={img1} alt="pfbjj" className="eventImg" />
      </div>
    </div>
  );
}

export default PastTourn;
